const config = {
  scrollToOptions: {
    container: 'body',
    easing: 'ease',
    offset: 0,
    cancelable: true,
    x: false,
    y: true
  }
}

export default config
